import { ContactsListingComponent } from './contacts-listing/contacts-listing.component';
import { UserGroupsListingComponent } from './user-groups-listing/user-groups-listing.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthenticatedComponent } from '../shared/layout/authenticated/authenticated.component';
import { AuthGuard } from 'app/shared/guards/auth.guard';
import { CreateContactComponent } from './create-contact/create-contact.component';
import { UploadContactComponent } from './upload-contact/upload-contact.component';
import { ProcessUploadComponent } from './process-upload/process-upload.component';
import { MoveContactsComponent } from './move-contacts/move-contacts.component';

const routes: Routes = [
  {
    path: 'user_contacts',
    component: AuthenticatedComponent,
    children: [
      {
        path: ':id/contacts',
        canActivate: [AuthGuard],
        component: ContactsListingComponent,
      },
      {
        path: 'user_groups',
        canActivate: [AuthGuard],
        component: UserGroupsListingComponent,
      },
      {
        path: 'new',
        canActivate: [AuthGuard],
        component: CreateContactComponent,
        data: {
          state: 'create',
        },
      },
      {
        path: ':id/edit',
        canActivate: [AuthGuard],
        component: CreateContactComponent,
        data: {
          state: 'edit',
        },
      },
      {
        path: 'add_contact',
        canActivate: [AuthGuard],
        component: UploadContactComponent,
      },
      {
        path: 'process_upload/:id',
        canActivate: [AuthGuard],
        component: ProcessUploadComponent,
      },
      {
        path: 'move',
        canActivate: [AuthGuard],
        component: MoveContactsComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContactsRoutingModule {}
